import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FeatureFlagsService } from '@app/services/feature-flags.service';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-age-verification',
  templateUrl: './age-verification.component.html',
  styleUrls: ['./age-verification.component.css']
})
export class AgeVerificationComponent implements OnInit {
  ageVerificationForm: FormGroup;
  isOver21: boolean | null = null;
  ssnVerified = false;
  showSSNForm = false;
  isFeatureEnabled$: Observable<boolean>;

  constructor(
    private fb: FormBuilder,
    private featureFlagsService: FeatureFlagsService
  ) {
    this.ageVerificationForm = this.fb.group({
      dob: ['', [Validators.required, this.dobValidator]],
      ssn: ['', [Validators.required, this.ssnValidator]]
    });
    this.isFeatureEnabled$ = this.featureFlagsService.isAgeVerificationEnabled();
  }

  ngOnInit(): void {}

  verifyAge() {
    const dobValue = this.ageVerificationForm.get('dob');
    const dob = dobValue ? this.ageVerificationForm.get('dob').value : null;
    if (!dob) return;

    const birthDate = new Date(dob);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      this.isOver21 = age - 1 >= 21;
    } else {
      this.isOver21 = age >= 21;
    }
  }

  verifySSN() {
    const ssnValue = this.ageVerificationForm.get('ssn');
    const ssn = ssnValue ? this.ageVerificationForm.get('ssn').value : null;
    if (!ssn) return;

    // Here you would typically make an API call to verify the SSN
    // For now, we'll just simulate a successful verification
    this.ssnVerified = true;
  }

  dobValidator(control: FormControl) {
    const dob = control.value;
    if (!dob) return null;

    const birthDate = new Date(dob);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    let actualAge = age;
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      actualAge = age - 1;
    }

    return actualAge >= 21 ? null : { underage: true };
  }

  ssnValidator(control: FormControl) {
    const ssn = control.value;
    if (!ssn) return null;

    const ssnRegex = /^(?!000|666|9\d{2})\d{3}[-]?(?!00)\d{2}[-]?(?!0000)\d{4}$/;
    return ssnRegex.test(ssn) ? null : { invalidSsn: true };
  }

  showSSNVerification() {
    this.showSSNForm = true;
  }

  resetForm() {
    this.ageVerificationForm.reset();
    this.isOver21 = null;
    this.ssnVerified = false;
    this.showSSNForm = false;
  }
} 